import './EditableTextField.scss'

import Textarea from 'react-textarea-autosize'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { KEYS_ENTER } from '../../constants/keyboardKeys'
import { removeCharacters } from '../../util/stringHelper'

class EditableTextField extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isFocused: false,
      isValid: true,
      isError: false,
      value: this.props.value
    }
  }

  componentWillUnmount() {
    this.saveChanges()
  }

  saveChanges = () => {
    this.setState({ isError: false })
    if (this.hasValidChange()) {
      this.props.onSave(this.state.value, this.onSaveError)
    }
  }

  hasValidChange = () => {
    return this.state.isValid && this.state.value !== this.props.value
  }

  onFocus = (event) => {
    this.setState({ isFocused: true })
  }

  onSaveError = () => {
    this.setState({ isError: true })
    this.setState({ value: this.props.value })
  }

  onBlur = (event) => {
    this.setState({ isFocused: false })
    if (this.hasValidChange()) {
      this.saveChanges()
    } else {
      this.setState({ value: this.props.value || '' })
      this.setState({ isValid: true })
    }
  }

  onChange = (event) => {
    let filtered = removeCharacters(
      event.target.value,
      {
        removeTabs: this.props.disallowCr,
        removeNewline: this.props.disallowCr
      })
    this.setState({ value: filtered })
    this.setState({
      isValid: !this.props.isRequired || filtered.trim() !== ''
    })
  }

  onKeyDown = (event) => {
    if (event.key === KEYS_ENTER && this.props.disallowCr) {
      this.setState({ value: this.state.value.trim() })
      event.preventDefault()
      document.activeElement.blur()
    }
  }

  render() {
    return <div
      className={classNames({
        'editableTextField': true,
        'editableTextField--hover': this.state.isMouseOver,
        'editableTextField--focus': this.state.isFocused,
        'editableTextField--invalid': !this.state.isValid,
        'editableTextField--error': this.state.isError
      })}>
      {
        <Textarea
          value={this.state.value}
          placeholder={this.props.placeHolderText}
          minRows={this.props.minRows || 1}
          maxRows={this.props.maxRows}
          onBlur={this.onBlur}
          onChange={this.onChange}
          onFocus={this.onFocus}
          maxLength={this.props.maxLength}
          onKeyDown={this.onKeyDown} />
      }
    </div>
  }
}

EditableTextField.propTypes = {
  value : PropTypes.string,
  placeHolderText: PropTypes.string.isRequired,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  maxLength: PropTypes.number,
  isRequired: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  disallowCr: PropTypes.bool
}

export default EditableTextField



// WEBPACK FOOTER //
// ./src/components/EditableTextField/EditableTextField.js